import { render, staticRenderFns } from "./FailPage.vue?vue&type=template&id=5c57c263&scoped=true&"
import script from "./FailPage.vue?vue&type=script&lang=ts&"
export * from "./FailPage.vue?vue&type=script&lang=ts&"
import style0 from "./FailPage.vue?vue&type=style&index=0&id=5c57c263&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c57c263",
  null
  
)

export default component.exports